var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('p',{staticClass:"contentType"},[_c('span',[_vm._v("Condition Type:")]),_c('span',[_vm._v(_vm._s(_vm.formName))])])]),_c('common-form',{ref:"commonForm",attrs:{"defaultData":_vm._commonData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }